export enum LoginTypes {
    Pin = 1,
    Badge = 2
}